'use strict';

import {getVueTemplate} from '../_imports/utils/utils.common';

const mediaImage = {
    template: getVueTemplate('media-image'),
    props: {
        image: Object
    },
    computed: {
        orientation() {
            return this.image.isLandscape ? 'landscape' : 'portrait';
        }
    },
    methods: {
        isLoaded() {
            this.$emit('is-loaded');
        },
        isLoadQuality() {
            if(this.image.src.includes('fast.wistia.com')) {
                return 'low-quality';
            }
        }
    }
};

export default mediaImage;